import { cn } from "@/lib/utils";
import type { ChapterImportance } from "@/types/book";

const styles: Record<ChapterImportance, string> = {
  HIGH: "bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-400",
  MEDIUM:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-400",
  LOW: "bg-green-100 text-green-700 dark:bg-green-900/50 dark:text-green-400",
};

export function ImportanceBadge({
  importance,
}: {
  importance: ChapterImportance;
}) {
  return (
    <span
      className={cn(
        "px-2 py-0.5 rounded text-xs font-medium shrink-0",
        styles[importance]
      )}
    >
      {importance}
    </span>
  );
}
